import { commaListSchema } from "@birdwatch/common";
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import { CoordinatorBooksReport } from "@/features/office/reports/coordinator-books";
import {
  filterSearchFragment,
  notificationSearchFragment,
  withOperators,
} from "@/features/shared/filters-new";
import { maskSearchFragment } from "@/features/shared/route-masking";

// Lenient URL schema (strict enums on URL params crash the page — see
// webapp-routing.md). Filter state follows the shared `filters-new` chip DSL:
// Market and Service Coordinator.
const searchSchema = z.object({
  sort: z.string().optional().catch(undefined),
  filters: z
    .object({
      market: withOperators(commaListSchema),
      coordinator: withOperators(commaListSchema),
      ...notificationSearchFragment,
    })
    .optional(),
  ...filterSearchFragment,
  ...maskSearchFragment,
});

export const routeId = "/office/reports/coordinator-books";
export const Route = createFileRoute("/office/reports/coordinator-books")({
  validateSearch: searchSchema,
  component: CoordinatorBooksReport,
});
